import _defineProperty from "/home/kms-config/ikos-kms-v2/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/kms-config/ikos-kms-v2/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useRef, useState } from 'react';
import { flushSync } from 'react-dom';
import { mergeRefs, useDidUpdate } from '@mantine/hooks';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
function getAutoHeightDuration(height) {
  if (!height || typeof height === "string") {
    return 0;
  }
  var constant = height / 36;
  return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
}
function getElementHeight(el) {
  return (el == null ? void 0 : el.current) ? el.current.scrollHeight : "auto";
}
var raf = typeof window !== "undefined" && window.requestAnimationFrame;
function useCollapse(_ref) {
  var transitionDuration = _ref.transitionDuration,
    _ref$transitionTiming = _ref.transitionTimingFunction,
    transitionTimingFunction = _ref$transitionTiming === void 0 ? "ease" : _ref$transitionTiming,
    _ref$onTransitionEnd = _ref.onTransitionEnd,
    onTransitionEnd = _ref$onTransitionEnd === void 0 ? function () {} : _ref$onTransitionEnd,
    opened = _ref.opened;
  var el = useRef(null);
  var collapsedHeight = "0px";
  var collapsedStyles = {
    display: "none",
    height: "0px",
    overflow: "hidden"
  };
  var _useState = useState(opened ? {} : collapsedStyles),
    _useState2 = _slicedToArray(_useState, 2),
    styles = _useState2[0],
    setStylesRaw = _useState2[1];
  var setStyles = function setStyles(newStyles) {
    flushSync(function () {
      return setStylesRaw(newStyles);
    });
  };
  var mergeStyles = function mergeStyles(newStyles) {
    setStyles(function (oldStyles) {
      return __spreadValues(__spreadValues({}, oldStyles), newStyles);
    });
  };
  function getTransitionStyles(height) {
    var _duration = transitionDuration || getAutoHeightDuration(height);
    return {
      transition: "height ".concat(_duration, "ms ").concat(transitionTimingFunction)
    };
  }
  useDidUpdate(function () {
    if (opened) {
      raf(function () {
        mergeStyles({
          willChange: "height",
          display: "block",
          overflow: "hidden"
        });
        raf(function () {
          var height = getElementHeight(el);
          mergeStyles(__spreadProps(__spreadValues({}, getTransitionStyles(height)), {
            height: height
          }));
        });
      });
    } else {
      raf(function () {
        var height = getElementHeight(el);
        mergeStyles(__spreadProps(__spreadValues({}, getTransitionStyles(height)), {
          willChange: "height",
          height: height
        }));
        raf(function () {
          return mergeStyles({
            height: collapsedHeight,
            overflow: "hidden"
          });
        });
      });
    }
  }, [opened]);
  var handleTransitionEnd = function handleTransitionEnd(e) {
    if (e.target !== el.current || e.propertyName !== "height") {
      return;
    }
    if (opened) {
      var height = getElementHeight(el);
      if (height === styles.height) {
        setStyles({});
      } else {
        mergeStyles({
          height: height
        });
      }
      onTransitionEnd();
    } else if (styles.height === collapsedHeight) {
      setStyles(collapsedStyles);
      onTransitionEnd();
    }
  };
  function getCollapseProps() {
    var _a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _b = _a,
      _b$style = _b.style,
      style = _b$style === void 0 ? {} : _b$style,
      _b$refKey = _b.refKey,
      refKey = _b$refKey === void 0 ? "ref" : _b$refKey,
      rest = __objRest(_b, ["style", "refKey"]);
    var theirRef = rest[refKey];
    return __spreadProps(__spreadValues({
      "aria-hidden": !opened
    }, rest), _defineProperty(_defineProperty(_defineProperty({}, refKey, mergeRefs(el, theirRef)), "onTransitionEnd", handleTransitionEnd), "style", __spreadValues(__spreadValues({
      boxSizing: "border-box"
    }, style), styles)));
  }
  return getCollapseProps;
}
export { getElementHeight, useCollapse };